import DeleteCell from "../components/DeleteCell";
import LinkCell from "../components/LinkCell";

/**
 * Constants used in the Tasks component
 */

export const CLUSTERS = {
  SCRAPER: "scraper-cluster",
  AUTO4CLIENT: "auto4client-cluster",
};

export const ALERT_MESSAGES = {
  DELETE_SUCCESS: "Task Deleted Successfully!",
  DELETE_ERROR: "Error Deleting Task!",
};

// Common column widths
export const COLUMN_WIDTHS = {
  LINK: 70,
  COMPANY: 160,
  DATE: 130,
  USER: 100,
  START_TIME: 300,
  TASK_DEFINITION: 800,
  DELETE: 100,
};

// Table column configuration
export const createTableColumns = (openDeleteDialog) => [
  {
    field: "link",
    headerName: "Link",
    width: COLUMN_WIDTHS.LINK,
    renderCell: (params) => <LinkCell params={params} />,
  },
  {
    field: "company",
    headerName: "Company",
    width: COLUMN_WIDTHS.COMPANY,
  },
  {
    field: "start_date",
    headerName: "Start Date",
    type: "date",
    width: COLUMN_WIDTHS.DATE,
  },
  {
    field: "end_date",
    headerName: "End Date",
    type: "date",
    width: COLUMN_WIDTHS.DATE,
  },
  {
    field: "user_id",
    headerName: "User",
    width: COLUMN_WIDTHS.USER,
  },
  {
    field: "start_time",
    headerName: "Start Time",
    width: COLUMN_WIDTHS.START_TIME,
  },
  {
    field: "task_definition_id",
    headerName: "Task Definition",
    width: COLUMN_WIDTHS.TASK_DEFINITION,
  },
  {
    field: "delete_task",
    headerName: "Delete Task",
    width: COLUMN_WIDTHS.DELETE,
    renderCell: (params) => <DeleteCell onDelete={openDeleteDialog} data={params} />,
  },
];
